import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Remet le scroll en haut à chaque changement de route.
 * À placer une fois dans chaque router (juste après <BrowserRouter>).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si l'URL contient une ancre (#xxx), laisse le navigateur faire son travail
    if (hash) return;
    // Sinon, scroll en haut instantanément (la transition de page gère le fade)
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
